if (typeof Ticker === 'undefined') {
  class Ticker extends HTMLElement {
    constructor() {
      super();
      this.animationFrame = null;
      this.isTickerVisible = true;
      this.lastTimestamp = performance.now();
    }

    connectedCallback() {
      const url = this.dataset.href;
      const openInNewTab = this.dataset.target === '_blank';

      if (url) {
        this.setAttribute('role', 'link');
        this.setAttribute('tabindex', '0');

        const navigate = () => {
          try {
            openInNewTab ? window.open(url, '_blank') : (window.location.pathname = url);
          } catch (error) {
            console.error('Error navigating to URL:', error);
          }
        };

        this.addEventListener('click', navigate);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate();
          }
        });
      }

      const speed = parseFloat(this.dataset.speed) || 2;
      const speedHover = parseFloat(this.dataset.speedHover) || 1;
      const direction = this.dataset.direction === 'normal' ? -1 : 1;
      const directionHover = this.dataset.directionHover === 'normal' ? -1 : 1;
      const wrapper = this.querySelector('.ticker-wrapper--outer');

      if (!wrapper) return console.error('No wrapper found inside <ticker-block>.');
      if (!this.querySelector('.ticker-wrapper__slide > *')) return console.error('No children found in <ticker-block>.');

      const tickerWrapper = document.createElement('div');
      tickerWrapper.className = 'ticker-wrapper';
      tickerWrapper.style.display = 'flex';
      tickerWrapper.style.gap = 'inherit';
      tickerWrapper.style.willChange = 'transform';

      const cloneWithoutPromoTracking = (item) => {
        const clone = item.cloneNode(true);
        clone.querySelectorAll('[data-promo-trigger], [data-tracking-id]').forEach((el) => {
          el.removeAttribute('data-promo-trigger');
          el.removeAttribute('data-tracking-id');
        });
        return clone;
      };

      const items = Array.from(wrapper.children);
      items.forEach((item) => tickerWrapper.appendChild(cloneWithoutPromoTracking(item)));

      wrapper.innerHTML = '';
      wrapper.appendChild(tickerWrapper);

      requestAnimationFrame(() => {
        const wrapperWidth = wrapper.clientWidth;
        const computedStyle = window.getComputedStyle(tickerWrapper);
        const gapValue = parseFloat(computedStyle.getPropertyValue('gap')) || 0;
        const setWidth = wrapper.querySelector('.ticker-wrapper__slide').clientWidth + gapValue;

        while (tickerWrapper.scrollWidth <= wrapperWidth * 2) {
          items.forEach((item) => tickerWrapper.appendChild(cloneWithoutPromoTracking(item)));
        }

        let scrollPosition = 0;
        let currentSpeed = speed;
        let currentDirection = direction;
        let isDragging = false;

        const resetScrollBounds = () => {
          if (Math.abs(scrollPosition) >= setWidth && currentDirection === -1) {
            scrollPosition = 0;
          }
          if (scrollPosition >= 0 && currentDirection === 1) {
            scrollPosition = -setWidth;
          }
        };

        const animate = () => {
          if (!this.isTickerVisible || document.hidden) return;

          const now = performance.now();
          const delta = now - this.lastTimestamp;
          this.lastTimestamp = now;

          if (!isDragging) {
            const dt = delta / (1000 / 60);
            scrollPosition += (currentSpeed / 100) * currentDirection * dt;
            resetScrollBounds();
            tickerWrapper.style.transform = `translateX(${scrollPosition}px)`;
          }

          this.animationFrame = requestAnimationFrame(animate);
        };

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isTickerVisible = entry.isIntersecting;
              if (this.isTickerVisible) {
                this.lastTimestamp = performance.now();
                this.animationFrame = requestAnimationFrame(animate);
              } else {
                cancelAnimationFrame(this.animationFrame);
              }
            });
          },
          { threshold: 0.1 },
        );

        observer.observe(wrapper);

        document.addEventListener('visibilitychange', () => {
          if (!document.hidden && this.isTickerVisible) {
            this.lastTimestamp = performance.now();
            this.animationFrame = requestAnimationFrame(animate);
          }
        });

        this.addEventListener('mouseenter', () => {
          currentSpeed = speedHover;
          currentDirection = directionHover;
        });

        this.addEventListener('mouseleave', () => {
          currentSpeed = speed;
          currentDirection = direction;
        });

        animate();
      });
    }
  }

  ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(
    (event) => {
      document.addEventListener(event, () => {
        if (!customElements.get('ticker-block')) customElements.define('ticker-block', Ticker);
      });
    },
  );

}